import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { recurringStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
}) =>
  priceType === paywallPriceTypes.subscription &&
  hasUpfrontPayment &&
  !hasTrialPeriod;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  buildOptions,
  currency,
  watch,
}) => {
  // Locale variables
  const member_charged_immediately_phrase = t(
    [localeRoot, "phrases", "member_charged_immediately"],
    {
      amount: formatPaywallCurrencyAmount(
        currency,
        mapCurrencyAmountStrToInt(watch("upfront_payment_amount")),
      ),
    },
  );

  return [
    ["upfront_then_subscription"],
    {
      member_charged_immediately_phrase,
      recurring_frequency:
        buildOptions.frequencies[
          watch("billing_frequency")
        ].as_phrase.toLowerCase(),
      recurring_amount: formatPaywallCurrencyAmount(
        currency,
        mapCurrencyAmountStrToInt(watch("amount")),
      ),
    },
  ];
};

export const upfrontThenSubscription: NoticeScenario = {
  matcher,
  stateValidator: recurringStateValidator,
  messagePropsResolver,
};
